/**
 * Navigate from an immersive react-router page (course editor / course player)
 * back into an activeTab-driven hub page, landing on a specific internal tab.
 *
 * The app shell renders hubs off `localStorage.activeTab` (see
 * WorkforceTabRedirect in main.tsx); HubShell consumes the one-shot
 * `hub_subtab:<hubKey>` key to pick its initial internal tab.
 */
import type { NavigateFunction } from 'react-router-dom';

export function navigateToHubTab(
  navigate: NavigateFunction,
  hubKey: string,
  subTab?: string,
) {
  try {
    localStorage.setItem('activeTab', hubKey);
    if (subTab) localStorage.setItem(`hub_subtab:${hubKey}`, subTab);
  } catch {
    /* private mode — the shell falls back to its default tab */
  }
  navigate('/');
}
